import React from 'react';
import { useAtom } from "jotai";
import convertToDollar from './utils/convertToDollar';
import { orderedMenuItemsAtom, totalPriceWithTaxAtom } from "./atoms";

const OrderList = () => {
    const [orderedItems] = useAtom(orderedMenuItemsAtom);
    const [orderTotal] = useAtom(totalPriceWithTaxAtom);
    
    const orderedItemList = orderedItems.map((item, index) => {
        return (
            <li className="passover-menu-list-item" key={index}>
                <div className="item-name">
                    <p>{item.name}</p>
                    <div className="item-subdetails">
                        <p className="item-subdetail">QTY: {item.quantity}</p>
                        <p className="item-subdetail">PRICE: {convertToDollar(item.price)}</p>
                    </div>
                </div>
                <p className="item-cost">{convertToDollar(item.cost)}</p>
            </li>
        );
    });
    
    return (
        <div className="order-list">
            <div className="table-headings">
                <p>Item</p>
                <p>Total</p>
            </div>
            <ul className="ordered-items-list">
                {orderedItemList}
            </ul>
            <div className="total-section">
                <p className="passover-menu-total">Order Total: {convertToDollar(orderTotal)}</p>
                <p className="tax-disclaimer">*tax included</p>
            </div>
        </div>
    )
}

export default OrderList;
